import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { flush, pageClosed, pageOpened } from "./usageTracker";

const SEND_EVERY_MS = 15000;

/**
 * Feeds route changes into usage analytics and sends what has been collected on a timer and when
 * the tab is hidden or closed. Renders nothing.
 *
 * @since NEXT_VERSION
 */
export function PageViewTracker() {
  const { pathname } = useLocation();

  useEffect(() => {
    pageOpened(pathname);
  }, [pathname]);

  useEffect(() => {
    const sendWhenHidden = () => {
      if (document.visibilityState === "hidden") flush();
    };
    const closeAndSend = () => {
      pageClosed();
      flush();
    };
    const timer = setInterval(flush, SEND_EVERY_MS);
    document.addEventListener("visibilitychange", sendWhenHidden);
    window.addEventListener("pagehide", closeAndSend);
    return () => {
      clearInterval(timer);
      document.removeEventListener("visibilitychange", sendWhenHidden);
      window.removeEventListener("pagehide", closeAndSend);
    };
  }, []);

  return null;
}
